/**
 * Operator-facing labels for ingest modes. Raw mode names ("sqs", "webhook")
 * are correct mechanically but read as dev jargon — these map to how
 * operators think about delivery cadence, with the mechanism as a
 * parenthetical so engineers can still reason back to the connector
 * capability key.
 *
 * Shared between the pipeline wizard's mode picker, the pipelines list's
 * TRIGGER column, and the pipeline detail badge.
 */
export const MODE_LABELS: Record<string, string> = {
  webhook: "Real-time (webhook)",
  sqs: "Real-time (event bus)",
  stream: "Real-time (stream)",
  poll: "Scheduled poll",
};

export function modeLabel(mode: string | null | undefined): string {
  if (!mode) return "—";
  return (MODE_LABELS[mode] ?? mode).toUpperCase();
}
